import { Component, Input, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { ElasticSearchService } from './search-elasticsearch.service';
import { UtilsService } from './utils.service';

@Component({
  selector: 'search-filters',
  template: `
    <p class="font-alt text-uppercase">
      <span class="search-filters-intro letter-spacing-4 font-weight-600"
        *ngIf="esFilters.length>1 || searchQueryParams!=null">
          {{title}}: </span>
          <span *ngIf="searchQueryParams!=null" title="search"> 
            <a (click)="onRemoveSearch()" title="search" class="pointer letter-spacing-3 search-filter">
              "{{esQuery.query.bool.must.multi_match.query}}" <small>x</small>
            </a>
      </span>
      <span *ngFor="let filter of esFilters" title="filter">
        <a *ngFor="let f of filter.term | mapToIterable" (click)="onRemoveFilter(f.key, f.value)" class="pointer letter-spacing-3 search-filter">
          <span *ngIf="f.key!='active'">
            {{labels && labels[f.key.replace('.raw','')].VALUES ? labels[f.key.replace('.raw','')].VALUES[f.value][language] : f.value | nameResolver}} &times;</span>
        </a>
      </span>
    </p>`
})
export class SearchFilterComponent implements OnInit{

  @Input() esQuery: Object[]; 
  @Input() esFilters: Object[];
  @Input() title: string;
  @Input() target: string;
  @Input() labels: any;
  @Input() language: string;
  searchQueryParams: string;
  filterQueryParams: string;

  constructor(private utils: UtilsService, private router: Router, private route: ActivatedRoute, private es: ElasticSearchService) {
  }

  hasActive(){
    this.esFilters.forEach(f => {
      if(f['term']['active']){
        console.log(f['term']['active']);
        return true;
      }
      return false;
    });
  }

  ngOnInit(){
    this.route.queryParams.subscribe(params => {
      this.searchQueryParams = params['s'];
      this.filterQueryParams = params['f'];
    });
  }

  onRemoveSearch(){
    this.es.clearSearchBox = true;
    this.es.searchQuery = this.es.query_search_all;
    // Nav
    let newQueryParams = { queryParams: {} };
    if(this.filterQueryParams)
      newQueryParams.queryParams['f'] = this.filterQueryParams;
    newQueryParams['relativeTo'] = this.route;
    this.router.navigate(['.'], newQueryParams);
  }

  onRemoveFilter(type: string, value: string){
    let newQueryParams = { queryParams: {} };
    // existing search
    if(this.searchQueryParams)
      newQueryParams.queryParams['s'] = this.searchQueryParams;
    // update filter params
    if(this.filterQueryParams) {
      let newFilterQueryParams = this.utils.removeQueryParam(this.filterQueryParams, type, value);
      if(newFilterQueryParams)
        newQueryParams.queryParams['f'] = newFilterQueryParams;
    }
    // go
    if(this.target)
      this.router.navigate([this.language+'/'+this.target], newQueryParams);
    else {
      newQueryParams['relativeTo'] = this.route;
      this.router.navigate(['.'], newQueryParams);
    }
  }

}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/shared/search-filter.component.ts